import { render, staticRenderFns } from "./AddMembers.vue?vue&type=template&id=65a9a95c&"
import script from "./AddMembers.vue?vue&type=script&lang=js&"
export * from "./AddMembers.vue?vue&type=script&lang=js&"
import style0 from "./AddMembers.vue?vue&type=style&index=0&id=65a9a95c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports